import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { EdlComment } from 'src/app/model/comment.model';
import { CommentState } from 'src/app/model/enum/comment-state.enum';
import { ObservationCommentService } from '../../services/observation-comment/observation-comment.service';

@Component({
    selector: 'app-observation-comments-indicator',
    templateUrl: './observation-comments-indicator.component.html',
    styleUrls: ['./observation-comments-indicator.component.scss']
})
export class ObservationCommentsIndicatorComponent implements OnInit, OnDestroy {
    @Input() domainFilterId?:string = '0';

    public draftCommentCount: number = 0;
    public publishedCommentCount: number = 0;

    private edlCommentsSubscription?: Subscription;

    constructor(private observationCommentService: ObservationCommentService) { }

    ngOnChanges(changes: SimpleChanges): void {
        const domainFilterId = changes['domainFilterId']?.currentValue;

        if (domainFilterId !== undefined) {
            this.setCommentCounts(domainFilterId ?? this.domainFilterId, this.observationCommentService.edlCommentsReplaySubject.getValue());
        }
    }

    ngOnInit(): void {
        this.edlCommentsSubscription = this.observationCommentService.edlCommentsReplaySubject.subscribe((comments) => this.setCommentCounts(this.domainFilterId, comments));
    }

    ngOnDestroy(): void {
        this.edlCommentsSubscription?.unsubscribe();
    }

    private setCommentCounts(domainFilterId?:string, comments: EdlComment[] = []) {
        const domainComments = (!domainFilterId || domainFilterId === '0') ? 
            comments : 
            comments.filter(x => x.lookupValue == this.domainFilterId);

        this.draftCommentCount = domainComments.filter(c => c.commentState === CommentState.DRAFT).length;
        this.publishedCommentCount = domainComments.filter(c => c.commentState === CommentState.PUBLISHED).length;
    }

}
